import { useTheme } from '@material-ui/core';
import NewModalMLStyled from './NewModalMLStyled';
import LoadingML from '@/components/LoadingML';
import { Card, CardContent } from '@material-ui/core';

const NewModalML = (props) => {
  const theme = useTheme();
  return (
    <NewModalMLStyled
      theme={theme}
      isHasBcg={props.isHasBcg}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      open={props.open}
      onClose={props.onClose}
      container={()=> document.getElementById("root")}
    >
      <LoadingML loading={props.loading} className="modal-content">
        <Card className="add-or-edt">
          <CardContent className="cardContent">{props.children}</CardContent>
        </Card>
      </LoadingML>
    </NewModalMLStyled>
  );
};
export default NewModalML;
